import { Component, Input, OnDestroy } from '@angular/core';
import { CanDisable, mixinDisabled } from '@angular/material/core';
import { Observable, Subject, filter, takeUntil, tap } from 'rxjs';
import { Milling } from '../../../models/cutting/cutting-panel-outline.model';
import { FacadeView } from '../../../models/cutting/facade-view.model';
import { LegacyDialogsService } from '../../../services/legacy-dialogs.service';
import { ApiLinks } from '../../cutting-panel-list/csl.api-links';
import { FacadeSettingsDataService } from '../facade-settings-data.service';
import { FacadeSettingsStateService } from '../facade-settings-state.service';
import { IMillingsDialogData, MillingsDialogComponent } from '../millings-dialog/millings-dialog.component';

export class MillingsBase {}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const _MillingsMixinBase = mixinDisabled(MillingsBase);

@Component({
  selector: 'csl-millings',
  templateUrl: './millings.component.html',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
})
export class MillingsComponent extends _MillingsMixinBase implements CanDisable, OnDestroy {
  @Input() userId = 0;

  panel$: Observable<FacadeView>;
  action$: Observable<any>;
  unsubscribe$: Subject<void> = new Subject();

  millings: Milling[] = [];

  constructor(
    private facadeSettingsService: FacadeSettingsStateService,
    private dialogsServices: LegacyDialogsService,

    private facadeSettingsDataService: FacadeSettingsDataService
  ) {
    super();

    this.facadeSettingsDataService
      .getMillingsForClient()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(res => (this.millings = res));

    this.panel$ = this.facadeSettingsService.panel$;
  }

  changeMilling(panel: FacadeView): void {
    const dialogData: IMillingsDialogData = { userId: this.userId, millings: this.millings };

    this.action$ = this.dialogsServices.component(MillingsDialogComponent, dialogData, 900).pipe(
      filter(r => !!r && r.length),
      tap(m => {
        panel.panelOutline.millings.length = 0;
        panel.panelOutline.millings.push(m[0]);
        this.facadeSettingsService.updatePanel(panel);
      })
    );
  }

  remove(item: Milling, panel: FacadeView): void {
    const index = panel.panelOutline.millings.indexOf(item);
    panel.panelOutline.millings.splice(index, 1);
    this.facadeSettingsService.updatePanel(panel);
  }

  getIconLink(item: Milling): string {
    if (!item) {
      return '';
    }

    return `${ApiLinks.millingsForClient}/${item.id}/icon?userId=${this.userId}`;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }
}
